/** @flow */
import Chart from 'components/Chart';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from 'components/base/Button';
import { preventPropagationStop } from 'components/hoc/propagation';
import numberToPrice from 'utils/currency/numberToPrice';
import formatDate from 'utils/date/formatDate';
import numberFormat from 'utils/number/format';
import { MemoryRouter } from "react-router-dom";

import css from './style.scss';
import Carousel from '../../Carousel';
import PropertyDetailPopup from '../../../Property/Detail/Detail';
import { connect } from 'react-redux';
// import MapCardPlaceHolder from 'components/base/Image/nophoto-mapcard.jpg'

import BedIcon from '../../../../assets/images/Bed.svg';
import Bath from '../../../../assets/images/Bath.svg';
import LotSize from '../../../../assets/images/LotSize.svg';
import SqFt from '../../../../assets/images/SqFt.svg';

import HighEquity from "../../../../assets/images/white-icons/HighEquity-White.svg";

import Auction from "../../../../assets/images/white-icons/Auctions-White.svg";
import OnMarket from "../../../../assets/images/white-icons/OnMarketMLS-White.svg";
import PreForeclosures from "../../../../assets/images/white-icons/PreForeclosures-White.svg";
import BankOwned from "../../../../assets/images/white-icons/BankOwned-White.svg";
import CashBuyers from "../../../../assets/images/white-icons/CashBuyer-White.svg";
import Liens from "../../../../assets/images/white-icons/Liens-White.svg";
import Vacant from "../../../../assets/images/white-icons/Vacant-White.svg";

import Bankruptcy from "../../../../assets/images/white-icons/Bankruptcy-White.svg";
import Divorce from "../../../../assets/images/white-icons/Divorce-White.svg";
import FailedListings from "../../../../assets/images/white-icons/FailedListings-White.svg";
import Flippers from "../../../../assets/images/white-icons/Flippers-White.svg";
import FreeClear from "../../../../assets/images/white-icons/FreeAndClear-White.svg";
import PreProbate from "../../../../assets/images/white-icons/PreProbate-White.svg";
import SeniorOwners from "../../../../assets/images/white-icons/SeniorOwners-White.svg";
import TaxDelinquency from "../../../../assets/images/white-icons/TaxDelinquency-White.svg";
import TiredLandlords from "../../../../assets/images/white-icons/TiredLandlords-White.svg";
import UpsideLand from "../../../../assets/images/white-icons/UpsideDown-White.svg";
import VacantLand from "../../../../assets/images/white-icons/VacantLand-White.svg";
import ZombieProperties from "../../../../assets/images/white-icons/ZombieProperties-White.svg";

//PropertyTypeIcons
import ResidentialIcon from '../../../../assets/images/ResidentialIcon.svg';
import CommercialIcon from '../../../../assets/images/CommercialIcon.svg';
import OfficeIcon from '../../../../assets/images/OfficeIcon.svg';
import IndustrialIcon from '../../../../assets/images/IndustrialIcon.svg';
import AgricultureIcon from '../../../../assets/images/AgricultureIcon.svg';
import RecreationalIcon from '../../../../assets/images/RecreationalIcon.svg';
import TransportationIcon from '../../../../assets/images/TransportationIcon.svg';
import ExemptIcon from '../../../../assets/images/ExemptIcon.svg';
import VacantLandIcon from '../../../../assets/images/VacantLandIcon.svg';

import NotSave from '../../../../assets/images/SaveIcon-NotSaved.svg';
import SaveIcon from '../../../../assets/images/SaveIcon-Saved.svg';
import SaveHoverIcon from '../../../../assets/images/SaveIcon-Hover.svg';
import BookmarkIcon from '../../../../assets/images/Bookmark.svg';
import RecentProperty from '../../RecentProperty';
import AssumableMtgSml from "../../../../assets/images/AssumableMtgSml.svg";
import AdditionalLeadListModal from '../../RecentListModal/ListModal';
import formatPercent from 'utils/percent/formatPercent';

const config = {
  A: [
    { name: 'auctionDate', label: 'Auction Date', format: value => formatDate(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['foreclosure', key]) : info?.foreclosure?.[key] },
    { name: 'unpaidBalance', label: 'Opening bid', format: value => numberToPrice(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['foreclosure', key]) : info?.foreclosure?.[key] },
    { name: 'documentType', label: 'Doc. Type', format: value => value, getValue: (info, key) => info.get ? info.getIn(['foreclosure', key]) : info?.foreclosure?.[key] },
  ],
  G: [
    {
      name: 'mortgage1LoanType',
      label: 'LOAN TYPE',
      format: value => value,
    },
    {
      name: 'mortgage1Balance',
      label: 'EST. LOAN BAL.',
      format: value => numberToPrice(value, 'N/A'),
    },
    {
      name: 'mortgage1InterestRate',
      label: 'EST. INT. RATE',
      format: value => formatPercent(parseFloat(value) * 100, null, {
        maximumFractionDigits: 2
      }),
    },
  ],
  F: [
    { name: 'lastSaleAmount', label: 'Sale Price', format: value => numberToPrice(value, 'N/A') },
    {
      name: 'lastSaleDate', label: 'Rec. Date', format: value => formatDate(value, 'N/A'),
    },
  ],
  B: [
    {
      name: 'recordingDate', label: 'Rec. Date', format: value => formatDate(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['bankruptcy', key]) : info?.bankruptcy?.[key],
    },
    { name: 'bankruptcyChapter', label: 'Chapter', format: value => value, getValue: (info, key) => info.get ? info.getIn(['bankruptcy', key]) : info?.bankruptcy?.[key], },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  C: [
    { name: 'lastSaleAmount', label: 'Sale Price', format: value => numberToPrice(value, 'N/A') },
    {
      name: 'lastSaleDate', label: 'Rec. Date', format: value => formatDate(value, 'N/A'),
    },
  ],
  D: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'recordingDate', label: 'Div. Recording', format: value => formatDate(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['divorce', key]) : info?.divorce?.[key], },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  Z: [
    {
      name: 'amount', label: 'Price', format: value => numberToPrice(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['mlsListing', key]) : info?.mlsListing?.[key],
    },
    {
      name: 'listingDate', label: 'status date', format: value => formatDate(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['mlsListing', key]) : info?.mlsListing?.[key],
    },
    { name: 'daysOnMarket', label: 'DAYS ON MKT.', format: value => value },
  ],
  I: [
    {
      name: 'amount',
      label: 'Price',
      format: value => numberToPrice(value, 'N/A'),
      getValue: (info) =>
        info.get ? info.get('lastSaleAmount') : info?.lastSaleAmount
    },
    {
      name: 'listingDate', label: 'status date', format: value => formatDate(value, 'N/A'),
      getValue: (info) =>
        info.get ? info.get('lastSaleDate') : info?.lastSaleAmount
    },
    {
      name: 'status',
      label: 'Status',
      format: value => value ? value.toUpperCase() : 'N/A',
      getValue: (info, key) => info.get ? info.getIn(['mlsListing', key]) : info?.mlsListing?.[key],
    }
  ],
  R: [
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
    {
      name: 'purchaseMethod', label: 'Pur. Method', format: value => value,
    },
  ],
  E: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  L: [
    {
      name: 'involuntaryLienAmount', label: 'Amount', format: value => numberToPrice(value, 'N/A'),
    },
    {
      name: 'listingDate', label: 'Rec. Date', format: value => formatDate(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['lien', key]) : info?.lien?.[key],
    },
    { name: 'documentType', label: 'Lien Type', format: value => value, getValue: (info, key) => info.get ? info.getIn(['lien', key]) : info?.lien?.[key] },
  ],
  M: [
    { name: 'amount', label: 'Price', format: value => numberToPrice(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['mlsListing', key]) : info?.mlsListing?.[key] },
    {
      name: 'mlsLastSaleDate',
      label: 'Status Date',
      format: value => formatDate(value, 'N/A'),
      getValue: info =>
        info.get
          ? info.getIn(['mlsListing', 'historicListings', 0, 'originalListingDate'])
          : info?.mlsListing?.historicListings?.[0]?.originalListingDate
    },
    { name: 'mlsStatus', label: 'Status', format: value => value },
  ],
  P: [
    {
      name: 'recordingDate', label: 'Rec. Date', format: value => formatDate(value, 'N/A'), getValue: (info, key) => info.get ? info.getIn(['foreclosure', key]) : info?.foreclosure?.[key],
    },
    { name: 'documentType', label: 'Doc. Type', format: value => value, getValue: (info, key) => info.get ? info.getIn(['foreclosure', key]) : info?.foreclosure?.[key] },
  ],
  DEC: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  S: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  X: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'delinquentTaxYear', label: 'Del. Year', format: value => value },
  ],
  T: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  UD: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  V: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  VLN: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'lastSaleDate', label: 'Last Sale', format: value => formatDate(value, 'N/A') },
  ],
  ZOM: [
    { name: 'equityPercentage', label: '', format: value => value },
    { name: 'estimatedEquity', label: 'Est. Equity', format: value => numberToPrice(value, 'N/A') },
    { name: 'openMortgageBalance', label: 'Est. Loan Bal.', format: value => numberToPrice(value, 'N/A') },
    { name: 'documentType', label: 'Doc. Type', format: value => value, getValue: (info, key) => info.get ? info.getIn(['foreclosure', key]) : info?.foreclosure?.[key] },
  ],
  G: [
    {
      name: 'mortgage1LoanType',
      label: 'LOAN TYPE',
      format: value => value,
    },
    {
      name: 'mortgage1Balance',
      label: 'EST. LOAN BAL.',
      format: value => numberToPrice(value, 'N/A'),
    },
    {
      name: 'mortgage1InterestRate',
      label: 'EST. INT. RATE',
      format: value => formatPercent(parseFloat(value) * 100, null, {
        maximumFractionDigits: 2
      }),
    },
  ],
};

const leadListMeta = {
  A: { label: 'Auctions', icon: Auction },
  B: { label: 'Bankruptcy', icon: Bankruptcy },
  C: { label: 'Cash Buyers', icon: CashBuyers },
  D: { label: 'Divorce', icon: Divorce },
  DEC: { label: 'Pre-Probate', icon: PreProbate },
  E: { label: 'High Equity', icon: HighEquity },
  F: { label: 'Bank Owned', icon: BankOwned },
  I: { label: 'Flippers', icon: Flippers },
  L: { label: 'Liens', icon: Liens },
  M: { label: 'On Market', icon: OnMarket },
  P: { label: 'Pre-Foreclosures', icon: PreForeclosures },
  R: { label: 'Free & Clear', icon: FreeClear },
  S: { label: 'Senior Owners', icon: SeniorOwners },
  T: { label: 'Tired Landlords', icon: TiredLandlords },
  UD: { label: 'Upside Down', icon: UpsideLand },
  V: { label: 'Vacant', icon: Vacant },
  VLN: { label: 'Vacant Land', icon: VacantLand },
  X: { label: 'Tax Delinquency', icon: TaxDelinquency },
  Z: { label: 'Failed Listings', icon: FailedListings },
  ZOM: { label: 'Zombie Properties', icon: ZombieProperties },
  G: { label: 'Assumable Mortgages', icon: AssumableMtgSml },
};
const CHART_WIDTH = 245;

const UiButton = preventPropagationStop(Button);

const CircularProgress = ({
  percentage = 0,
  size = 24,
  strokeWidth = 4,
  color = '#4caf50',
  backgroundColor = '#e0e0e0'
}) => {
  const isNegative = percentage < 0;
  const showDashed = percentage < -99;
  const absPercentage = Math.min(Math.abs(percentage), 100);

  const adjustedSize = size + strokeWidth;
  const radius = (size) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (absPercentage / 100) * circumference;

  let textValue = '';
  if (percentage < -99) {
    textValue = '--';
  } else if (percentage > 0) {
    textValue = `${Number.isInteger(percentage) ? percentage : percentage.toFixed(1)}`;
  } else {
    textValue = `${Number.isInteger(percentage) ? percentage : percentage.toFixed(1)}`;
  }

  return (
    <svg
      width={adjustedSize}
      height={adjustedSize}
      viewBox={`0 0 ${adjustedSize} ${adjustedSize}`}
      style={{ textAlign: "center" }}
    >
      {/* Background circle */}
      <circle
        stroke={backgroundColor}
        fill="none"
        strokeWidth={strokeWidth}
        cx={adjustedSize / 2}
        cy={adjustedSize / 2}
        r={radius}
      />

      {/* Progress circle */}
      {!showDashed && (
        <circle
          stroke={isNegative ? 'red' : color}
          fill="none"
          strokeWidth={strokeWidth}
          cx={adjustedSize / 2}
          cy={adjustedSize / 2}
          r={radius}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(${isNegative ? 90 : -90} ${adjustedSize / 2} ${adjustedSize / 2})`}
        />
      )}

      {/* Text value */}
      <text
        x="50%"
        y="50%"
        dy="1px"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="11"
        fill={isNegative ? 'red' : color}
        fontWeight="800"
      >
        {textValue}
      </text>
    </svg>
  );
};

class PropertyInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      isSaveHovered: false,
      isShowLinear: true,
      isIconHovered: false,
      isModalOpen: false,
      modalPropertyId: null,
    };
  }

  componentDidMount() {
    const { info, loading, property } = this.props;
    const id = info.get('propertyId') || info.get('id');

    if (!loading && id !== property.get('id')) this.props.getProperty(id, 'M');
    if (!loading && id !== property.get('id')) this.props.getPropertyContact(id, () => { });
  }

  handleSave = () => {
    const { handleSaveProperty, info } = this.props;
    const id = info.get('propertyId') || info.get('id');
    if (handleSaveProperty) {
      handleSaveProperty(id);
    }
  };

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  showLinear = (e) => {
    this.setState({ isShowLinear: e });
  }


  handleSaveMouseEnter = () => {
    this.setState({ isSaveHovered: true });
  };

  handleSaveMouseLeave = () => {
    this.setState({ isSaveHovered: false });
  };

  state = {
    showTitle: false
  };


  handleMouseEnter1 = (e) => {
    const el = e.target;
    if (el.offsetWidth < el.scrollWidth) {
      this.setState({ showTitle: true });
    } else {
      this.setState({ showTitle: false });
    }
  };

  handleAdditionalClick = (item, e) => {
    // e?.stopPropagation?.();
    this.setState({
      isModalOpen: true,
      modalPropertyId: item.get('id'),
    });
  };

  render() {
    const {
      info: data,
      saveProperty,
      loading,
      history,
      property,
      onCloseClick,
      searchType,
      onNearbyClick,

      // NEW: Feature flags
      saveEnabled = true,
      nearbySearchEnabled = true,
      photoGalleryEnabled = true,
      closeButtonEnabled = true,
      hoverEffectsEnabled = true,
      cardStyle = 'default', // 'default' or 'compact'

      // DEPRECATED: Keep for backward compatibility
      context = 'map',
      hideSave = false,
      hideNearby = false,
      hidePhoto = false,
      hideClose = false,
    } = this.props;

    // BACKWARD COMPATIBILITY: Map old props to new feature flags
    const finalSaveEnabled = context === 'campaign' ? false : (hideSave ? false : saveEnabled);
    const finalNearbyEnabled = context === 'campaign' ? false : (hideNearby ? false : nearbySearchEnabled);
    const finalPhotoEnabled = context === 'campaign' ? false : (hidePhoto ? false : photoGalleryEnabled);
    const finalCloseEnabled = context === 'campaign' ? false : (hideClose ? false : closeButtonEnabled);
    const finalHoverEnabled = context === 'campaign' ? false : hoverEffectsEnabled;
    const finalCardStyle = context === 'campaign' ? 'compact' : cardStyle;

    const info = property || data;
    const propertyId = info.get('propertyId') || info.get('id');
    const address = info.get('address', Map());
    const cityName = address.get('cityName', '');
    const streetAddress = address.get('streetAddress', '');
    const propertyType = info.get('propertyType');
    const propertyClass = info.get('propertyClass');

    const formattedPropertyClass = (() => {
      if (!propertyClass) return '';

      const pretty = propertyClass.charAt(0).toUpperCase() + propertyClass.slice(1).toLowerCase();

      return propertyClass.toUpperCase() === 'VACANT' ? `${pretty} Land` : pretty;
    })();

    const landUse = info.get('landUse');
    const yearBuilt = info.get('yearBuilt');
    const bedrooms = info.get('bedrooms');
    const bathrooms = info.get('bathrooms');
    const squareFeet = info.get('squareFeet');
    const lotSquareFeet = info.get('lotSquareFeet');
    const addressString = `${streetAddress} ${cityName}`;
    const result = {};
    const btn = { kind: Button.kind.ghost, size: Button.size.middle, isLoading: loading };
    const saved = !!info.get('savedPropertyId');
    const images = info.get('imageUrls');
    const savedPropertyCount = info.get('savedPropertyCount');
    const groupName = info.getIn(['group', 'name']) || '';
    const groupId = info.getIn(['group', 'id']);
    const lien = info.get('lien');
    const apartmentInfo = lien ? lien.set('type', 'LIEN') : info;
    const apartmentFields = config[apartmentInfo.get('type')] || config.default;

    const estimatedValueGraph = info.get('estimatedValueGraph');
    const estimatedValue = info.get('estimatedValue');
    const equityPercentage = info.get('equityPercentage')
    const oneYearPoint = estimatedValueGraph.get('points')?.toJS()?.find(p => p.label === "1yr")?.value;

    const C = oneYearPoint ? ((estimatedValue - oneYearPoint) / oneYearPoint) * 100 : 0;

    const roundedC = Math.round(C);
    const formattedC = `${roundedC > 0 ? '+' : ''}${roundedC}%`;

    let imageUrl = info.get('imageUrls', '');
    if (!loading && (!imageUrl || imageUrl.includes('/coming_soon.') || imageUrl.includes('/house-img-not-available.'))) imageUrl = "placeholder";

    const link = `/search/${info.get('propertyId')}`;

    //const fullAddress = `${item.getIn(['address', 'streetAddress'])} ${item.getIn(['address', 'cityName'])} ${item.getIn(['address', 'stateCode'])} ${item.getIn(['address', 'zip'])}`;

    const street = info.getIn(['address', 'streetAddress']) || '';
    const city = info.getIn(['address', 'cityName']) || '';
    const state = info.getIn(['address', 'stateCode']) || '';
    const zip = info.getIn(['address', 'zip']) || '';

    const isValid = (val) =>
      typeof val === 'string' &&
      val.trim() !== '' &&
      !val.includes('0000') &&
      !val.includes('00000') &&
      !val.includes('<No Street Address>') &&
      val.toLowerCase() !== 'undefined';
    // Build the clean address parts
    let fAddress = '';

    if (isValid(street)) fAddress += street;

    if (isValid(city)) {
      if (fAddress) fAddress += ' ';
      fAddress += city;
    }

    const stateZip = [state, zip].filter(isValid).join(' ');
    if (stateZip) {
      if (fAddress) fAddress += ', ';
      fAddress += stateZip;
    }

    const fullAddress = isValid(state) && fAddress.trim() == state ? 'Address Unavailable' : fAddress || 'Address Unavailable';

    const iconMap = {
      RESIDENTIAL: ResidentialIcon,
      COMMERCIAL: CommercialIcon,
      OFFICE: OfficeIcon,
      INDUSTRIAL: IndustrialIcon,
      AGRICULTIRAL: AgricultureIcon,
      RECREATIONAL: RecreationalIcon,
      TRANSPORTATION: TransportationIcon,
      EXEMPT: ExemptIcon,
      VACANT: VacantLandIcon,
    };

    const typeFields = config[searchType] || [];

    const hasEquityPercentage = typeFields.some(field => field.name === 'equityPercentage');

    const getIcon = () => {
      if (saved) return SaveIcon;
      return this.state.isSaveHovered ? SaveHoverIcon : NotSave;
    };

    const hasLeadList = searchType && searchType !== 'O';

    const enableShift =
      images !== undefined &&
      (this.state.isHovered &&
        this.state.isShowLinear);

    // Helper function for address click navigation
    const handleAddressClick = () => {
      const campaignId = history.location.pathname.match(/\/campaign\/(\d+)\/dialer/)?.[1];
      if (campaignId) {
        const action = PropertyDetailPopup.open({
          propertyId,
          preventRouting: true,
          match: { params: { id: propertyId } }
        });
        if (this.props.dispatch) {
          this.props.dispatch(action);
        } else {
          console.error("Dispatch is not available in PropertyInfo");
          history.push(`/search/${info.get('id')}`);
        }
      } else {
        history.push(`/search/${info.get('id')}`);
      }
    };

    return (
      <div className={`${css.info} ${finalCardStyle === 'compact' ? css.compactCard : ''}`}>
        <div className={css.details}>
          <div
            className={`${css.image} ${finalCardStyle === 'compact' ? css.compactImage : ''} ${(this.state.isHovered || finalCardStyle !== "compact") ? css.hovered : ''} ${hasLeadList ? css.hasLeadList : ''} ${(!images || finalCardStyle !== "compact") ? css.noHover : ''} ${(searchType != undefined && searchType != "O") ? css.isUndefined : ''} ${this.state.isShowLinear === false ? (searchType != "O" && searchType != undefined ? css.imageHeightUndefined : css.imageHeight) : ''}`}
            onMouseEnter={finalHoverEnabled ? this.handleMouseEnter : undefined}
            onMouseLeave={finalHoverEnabled ? this.handleMouseLeave : undefined}
          >
            <Carousel
              className={css.carousel}
              loading={loading}
              propertyId={propertyId}
              images={images}
              history={history}
              imageUrlString={imageUrl}
              alt={addressString}
              onCloseClick={onCloseClick}
              isHovered={this.state.isHovered}
              showLinear={this.showLinear}
              onNearbyClick={(id) => onNearbyClick(id, 'P', info.getIn(['address', 'streetAddress']), info.get('apn'), info.getIn(['address', 'cityId']), true)}
              // Pass feature flags to Carousel
              nearbySearchEnabled={finalNearbyEnabled}
              photoGalleryEnabled={finalPhotoEnabled}
              closeButtonEnabled={finalCloseEnabled}
              hoverEffectsEnabled={finalHoverEnabled}
              cardStyle={finalCardStyle}
              store={this.props.store}
            />
            <div
              className={`${css.gradientOverlay} ${finalCardStyle === 'compact' ? css.compactGradient : ''} ${enableShift ? css.shifted : ''} ${this.state.isShowLinear === false ? css.hideLinear : ''}`}
            >
            </div>
          </div>

          <div className={`${css.propertyDetails} ${finalCardStyle === 'compact' ? css.compactDetails : ''} ${enableShift ? css.shifted : ''} ${hasLeadList ? css.hasLeadList : ''} `}>
            {loading != true &&
              <div>
                <div className={css.topIcons}>
                  <div className={css.headResult}>
                    <div className={css.tagParent}>
                      <div className={`${css.tag} ${css.fadeInOut}`}
                        onMouseEnter={() => this.setState({ isIconHovered: true })}
                        onMouseLeave={() => this.setState({ isIconHovered: false })}
                      >
                        <img
                          src={iconMap[propertyClass?.toUpperCase()] || ResidentialIcon}
                          className={css.iconProperties}
                          alt={propertyClass}
                        />
                        <span className={css.res} style={{ height: '28px', padding: '5px 0' }}>
                          {formattedPropertyClass}
                          {landUse ? ` – ${landUse}` : ''}
                        </span>

                      </div>
                    </div>
                    <div className={css.fadeChild}>
                      {saved &&
                        <RecentProperty
                          listName={groupName}
                          count={savedPropertyCount}
                          groupId={groupId}
                          isIconHovered={this.state.isIconHovered}
                          history={history}
                          redirectFlag={false}
                          disabled={false}
                          onAdditionalClick={(e) => this.handleAdditionalClick(info, e)}
                        />
                      }
                    </div>
                  </div>

                  <div className={css.saveIconsContainer}>
                    {info.get('onMarket') === true ? (
                      <div className={css.bookmark}>
                        <div className={css.value}>
                          {typeof info.getIn(['mlsListing', 'amount']) === 'number' && !isNaN(info.getIn(['mlsListing', 'amount'])) ? (
                            <>
                              <span>
                                {numberToPrice(info.getIn(['mlsListing', 'amount']))}
                              </span>
                              <span className={css.estvalue}> LIST PRICE </span>
                            </>
                          ) : (
                            'N/A'
                          )}
                        </div>
                      </div>
                    ) : (
                      !numberToPrice(info.get('estimatedValue', 0)) ? null : (
                        <div className={css.bookmark}>
                          <div className={css.value}>
                            {typeof info.get('estimatedValue') === 'number' && !isNaN(info.get('estimatedValue')) ? (
                              <>
                                <span>
                                  {numberToPrice(info.get('estimatedValue'))}
                                </span>
                                <span className={css.estvalue}> EST. VALUE </span>
                              </>
                            ) : (
                              'N/A'
                            )}
                          </div>
                        </div>
                      )
                    )}
                    {/* Use finalSaveEnabled instead of context check */}
                    {finalSaveEnabled && (
                      <div className={css.topIcons}>
                        <div className={`${css.tag} ${css.hoverable} ${saved ? css.disabled : ''}`}
                          onMouseEnter={!saved ? this.handleSaveMouseEnter : undefined}
                          onMouseLeave={!saved ? this.handleSaveMouseLeave : undefined}
                          onClick={!saved ? () => this.handleSave() : undefined}
                        >
                          <span className={css.res}>Save</span>
                          <img
                            src={getIcon()}
                            className={css.iconProperties}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                <span
                  className={css.name}
                  title={this.state.showTitle ? fullAddress : ''}
                  onMouseEnter={this.handleMouseEnter1}
                  onClick={handleAddressClick}
                >
                  {fullAddress}
                  {/* {streetAddress}{' '}
              {cityName}
              {cityName ? ', ' : ''}
              {address.get('stateCode', '')} {address.get('zip', '')} */}
                </span>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  {[
                    { value: bedrooms, icon: BedIcon, label: "Bd." },
                    { value: bathrooms, icon: Bath, label: "Ba." },
                    { value: squareFeet, icon: SqFt, label: "SQFT" },
                    { value: lotSquareFeet, icon: LotSize, label: "LOT" }
                  ]
                    .filter(c => c.value)
                    .map((c, index, arr) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        {/* Icon + Text */}
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <img
                            src={c.icon}
                            alt={c.label}
                            style={{ width: "20px", height: "20px" }}
                          />
                          <span className={css.iconCounts}>
                            {numberFormat(c.value)}
                            {(c.label === "SQFT" || c.label === "LOT") && (
                              <span
                                style={{
                                  color: "#66707D",
                                  fontSize: "12px",
                                  fontFamily: "Inter",
                                  fontWeight: 600,
                                  position: "relative",
                                  fontStyle: "normal",
                                  lineHeight: "12px",
                                  textTransform: "uppercase"
                                }}
                              >
                                {c.label}
                              </span>
                            )}
                          </span>

                        </div>

                        {/* Separator */}
                        {index !== arr.length - 1 && (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "8px"
                            }}
                          >
                            <div
                              style={{
                                width: "1px",
                                height: "20px",
                                backgroundColor: "#DFE1E4"
                              }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                </div>
                <div
                  style={{ borderBottom: '1px solid #DFE1E4', width: '100%', margin: '12px 0' }}
                />
                <div className={css.footer}>
                  {info.get('estimatedEquity') != null && info.get('estimatedEquity') !== '' && info.get('estimatedEquity') !== '-'
                    &&
                    <CircularProgress percentage={equityPercentage} color="#128292" backgroundColor="#DFE1E4" />
                  }

                  <div className={css.fieldGroup}>
                    {info.get('estimatedEquity') != null && info.get('estimatedEquity') !== '' && info.get('estimatedEquity') !== '-' && (
                      <>
                        <div className={css.field}>
                          <span className={css.title}>EST. EQUITY</span>
                          <span className={css.value}>{numberToPrice(info.get('estimatedEquity'), '-')}</span>
                        </div>
                        <div className={css.separator} />
                      </>
                    )}

                    {formattedC && formattedC !== '-' && (
                      <>
                        <div className={css.field}>
                          <span className={css.title}>1 YR. VAL. CHANGE</span>
                          <span className={css.value}>{formattedC}</span>
                        </div>
                        <div className={css.separator} />
                      </>
                    )}

                    {info.get('compSaleAmount') != null && info.get('compSaleAmount') !== '' && info.get('compSaleAmount') !== '-' && (
                      <>
                        <div className={css.field}>
                          <span className={css.title}>AVG. COMPS</span>
                          <span className={css.value}>{numberToPrice(info.get('compSaleAmount'), '-')}</span>
                        </div>
                        <div className={css.separator} />
                      </>
                    )}

                    {info.get('rentAmount') != null && info.get('rentAmount') !== '' && info.get('rentAmount') !== '-' && (
                      <div className={css.field}>
                        <span className={css.title}>EST. RENT</span>
                        <span className={css.value}>{numberToPrice(info.get('rentAmount'), '-')}</span>
                      </div>
                    )}
                  </div>
                </div>

                {(searchType != undefined && searchType != "O") &&
                  <div className={css.footerDetails}>
                    <div className={css.filterList}>
                      <div className={css.iconWrapper}>
                        <img src={leadListMeta[searchType]?.icon} alt={leadListMeta[searchType]?.label || 'Lead Type'} />
                      </div>
                      <div className={css.filterListType}>
                        <span>Lead List: {leadListMeta[searchType]?.label || 'Unknown'}</span>
                      </div>
                    </div>
                    <div className={css.rightSide}>
                      {hasEquityPercentage &&
                        (info.get?.('equityPercentage') !== null &&
                          info.get?.('equityPercentage') !== '' &&
                          info.get?.('equityPercentage') !== '-' &&
                          info.get?.('equityPercentage') !== undefined) && (
                          <div className={`${css.field} ${css.progressField}`}>
                            <CircularProgress
                              percentage={info.get ? info.get('equityPercentage') : info['equityPercentage'] || 0}
                              color="#ffffff"
                              backgroundColor="#53A6B2"
                            />
                          </div>
                        )}

                      {(() => {
                        let visibleFields = typeFields.filter((field) => {
                          if (field.name === 'equityPercentage') return false;

                          const rawValue = field.getValue
                            ? field.getValue(info, field.name)
                            : info.get
                              ? info.get(field.name)
                              : info[field.name];

                          return !(rawValue === 'N/A' || rawValue === '' || rawValue == null);
                        });

                        return visibleFields.map((field, i) => {
                          const rawValue = field.getValue
                            ? field.getValue(info, field.name)
                            : info.get
                              ? info.get(field.name)
                              : info[field.name];

                          const fieldContent = (
                            <div key={field.label} className={css.field}>
                              <span className={css.title}>{field.label}</span>
                              <span
                                className={css.value}
                                title={
                                  typeof field.format(rawValue) === 'string' &&
                                    isNaN(field.format(rawValue))
                                    ? field.format(rawValue)
                                    : undefined
                                }
                              >
                                {field.format(rawValue)}
                              </span>
                            </div>
                          );

                          return (
                            <React.Fragment key={field.label}>
                              {/* add separator only if NOT the first item */}
                              {i > 0 && <div className={css.fieldFixedLine}></div>}
                              {fieldContent}
                            </React.Fragment>
                          );
                        });
                      })()}
                    </div>
                  </div>
                }
              </div>
            }
          </div>

          {/* <AdditionalLeadListModal
            isOpen={this.state.isModalOpen}
            onClose={() => this.setState({ isModalOpen: false, modalPropertyId: null })}
            propertyId={this.state.modalPropertyId}
            history={history}
            displayResults={this.state.displayResults}
          /> */}

        </div>
      </div >
    );
  }
}


PropertyInfo.propTypes = {
  info: PropTypes.instanceOf(Map).isRequired,
  property: PropTypes.instanceOf(Map),
  saveProperty: PropTypes.func.isRequired,
  getProperty: PropTypes.func,
  handleSaveProperty: PropTypes.func,

  // NEW: Feature flags (TL's recommended approach)
  saveEnabled: PropTypes.bool,
  nearbySearchEnabled: PropTypes.bool,
  photoGalleryEnabled: PropTypes.bool,
  closeButtonEnabled: PropTypes.bool,
  hoverEffectsEnabled: PropTypes.bool,
  cardStyle: PropTypes.oneOf(['default', 'compact']),

  // Other props
  loading: PropTypes.bool,
  history: PropTypes.object.isRequired,
  onCloseClick: PropTypes.func,
  searchType: PropTypes.string,
  onNearbyClick: PropTypes.func,

  // DEPRECATED - keeping for backward compatibility
  context: PropTypes.oneOf(['map', 'campaign']),
  hideSave: PropTypes.bool,
  hideNearby: PropTypes.bool,
  hidePhoto: PropTypes.bool,
  hideClose: PropTypes.bool,
};

PropertyInfo.defaultProps = {
  // Feature flags - default to all enabled (map view behavior)
  saveEnabled: true,
  nearbySearchEnabled: true,
  photoGalleryEnabled: true,
  closeButtonEnabled: true,
  hoverEffectsEnabled: true,
  cardStyle: 'default',

  // Deprecated props
  context: 'map',
  hideSave: false,
  hideNearby: false,
  hidePhoto: false,
  hideClose: false,
};

export default connect()(PropertyInfo);